import React, { ReactNode } from 'react';

export type FormSubmitParams = {
    cssName?: string;
    lbl?: string;
    lblWidth?: string;
    children: ReactNode;
};

const FormSubmit = ({ cssName, lbl, lblWidth, children }: FormSubmitParams): JSX.Element => {
    return (
        <div className={'form-field form-submit ' + (cssName ? cssName : '')}>
            <label className={lblWidth}>{lbl}</label>
            {children}
        </div>
    );
};

export default FormSubmit;
